import { useNavigate } from "react-router";
import SyIcon from "../../../../shared/components/sy-icon";
import { table_header } from "./live-details-config";
import styleSheet from "./style.module.scss";
import { useState } from "react";

import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getOrbitDetails } from "../../../../feature/orbit-slice";
import { orbitParamValue } from "../../../../utils/helper";
import { useTranslation } from "react-i18next";

const LiveDetailsPop = (props: any) => {
  const { onClose, liveData } = props;
  const navigate = useNavigate();
  const orbitInfo = useSelector(getOrbitDetails);
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<any>(orbitParamValue(searchParams));
  const { t } = useTranslation();
  const getTableHeaders = ({ th_classname, th_name, index }: any) => {
    return (
      <th key={index} className={`${th_classname} text-truncate`} scope="col">
        {t(th_name)}
      </th>
    );
  };

  const navPlanetDetails = (id: any) => {
    navigate({
      pathname: `/view/planet/${orbitInfo.selectOrbit}/${id}`,
      search: `?fr=${params.fr}`,
    });
  };

  const getTableContent = ({ data, index }: any) => {
    return (
      <tr key={index} className="lh-lg">
        <td className="text-center position-sticky start-0 table-cell-bg text-truncate">
          <img
            className={`rounded-circle`}
            width={"40px"}
            src={data.category_image}
          />
        </td>
        <td className="text-truncate">{data.pro_name}</td>

        <td className="text-truncate">{data.pro_address}</td>
        <td className="text-truncate">{data.pro_contact_name}</td>
        <td className="text-truncate">{data.pro_contact_email}</td>
        <td className="text-truncate">{data.pro_contact_phone}</td>

        <td className="text-center position-sticky end-0 table-cell-bg text-truncate">
          <SyIcon
            name={"edit"}
            className={"opacity-50 ms-2 pointer"}
            iconType={data.iconType}
            iconColor={data?.iconColor}
            onClick={() => navPlanetDetails(data.pro_id)}
          />
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className={`rounded-4  p-3 pop-bg ${styleSheet.main}`}>
        <div className="d-flex align-items-center justify-content-between pb-3">
          <h2 className="mohave m-0 title-font">{t(`live_planets`)}</h2>
          <SyIcon
            name="close"
            iconType="symbols"
            iconStyle="outlined"
            iconColor="white"
            className={` pointer`}
            onClick={onClose}
          />
        </div>
        <div className="mt-3">
          <table className={`${styleSheet.table_style} w-100`}>
            <thead className="lh-lg mohave-bold ">
              <tr>
                {table_header.map((data: any, index: number) =>
                  getTableHeaders({ ...data, index: index })
                )}
              </tr>
            </thead>
            <tbody className="position-relative mohave">
              {liveData.length ? (
                liveData.map((data: any, index: number) =>
                  getTableContent({ data, index: index })
                )
              ) : (
                <div className=" position-absolute position-absolute mt-5 end-50">
                  <p>{t("no_data_found")}</p>
                </div>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default LiveDetailsPop;
